export enum QuoteIssueType {
  ETF = 'ETF',
  INDEX = 'INDEX',
  MF = 'MF',
  OPTION = 'OPTION',
  STOCK = 'STOCK'
}
